import { ActionType } from '../infrastructure/actionTypes';
import { IUserData } from '../infrastructure/interfaces';

export interface IUserState {
  data: IUserData | null;
  loginFailed: boolean;
}

const initialState: IUserState = {
  data: null,
  loginFailed: false,
};


export default (state = initialState, action: any) => {
  switch (action.type) {
    case ActionType.LOGGING_IN:
      return { ...state, isLoading: true, loginFailed: false };
    case ActionType.LOGGED_IN:
      const user = {"id":action.payload.id, "role":action.payload.role, "email":action.payload.email};
      if (user) {
        return { ...state, data: user };
      }
      return state;
    case ActionType.LOGGED_OUT:
      return initialState;
    case ActionType.LOGIN_FAILED:
      return { ...state, loginFailed: true };
    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/reducers/user.ts